import { render, staticRenderFns } from "./AddSkill.vue?vue&type=template&id=f6f9f1a4&"
import script from "./AddSkill.vue?vue&type=script&lang=js&"
export * from "./AddSkill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports